<div class="position-relative theme-search-wrap" [ngClass]="themeClass('search-section1')">
    <div class="search-bar">
        <div class="d-flex">
            <!-- <span *ngIf="categoryName" class="intial-value"><i class="fa fa-solid fa-xmark"
                    (click)="onClickSearchByPartName()"></i> {{categoryName}}</span> -->
            <!--<input type="search" class="form-control" #searchInput placeholder="Search by keywords, Product name or Part #"
                [(ngModel)]="searchValueByPartName" (ngModelChange)="onInputvalueChangeByPartName()" (keyup.enter)="onEnterClickSearch(searchInput.value)" />-->
            <input type="search" class="form-control" #searchInput
                [placeholder]="placeholder_title" [(ngModel)]="searchValueByPartName"
                (ngModelChange)="onInputvalueChangeByPartName()" (keydown.enter)="onEnterClickSearch(searchInput.value)"
                (search)="onEnterClickSearch(searchInput.value)" autocapitalize="none" enterkeyhint="search" />
        </div>
        <span *ngIf="!searchValueByPartName" class="position-absolute top-50 end-0 translate-middle-y img-icon">
            <img [src]="commonImagePath+blackSearch" class="pb-0 kds-search" alt="search-icon" />
        </span>
    </div>
    <div *ngIf="searchResultArrayByPartName?.length || showDefault || searchResultArrayByCatName?.length"
        class="position-absolute w-100 zindex-dropdown">
        <div class="dropdown-menu show w-100  shadow-sm border">
            <!-- Show default Items  -->
            <!-- <div *ngIf="showDefault">
                <ng-container *ngFor="let item of defaultArrayList; let last = last">
                    <div [ngClass]="{'border-bt': !last}">
                        <a type="button" class="dropdown-item text-wrap test" (click)="select_Category(item.name)">
                            {{item.name}}
                        </a>
                    </div>
                </ng-container>
            </div> -->
            <!-- Product Name Row -->
            <ng-container *ngFor="let result of searchResultArrayByPartName; let last = last">
                <div [ngClass]="{'border-bt': !last}">
                    <a type="button" class="dropdown-item text-wrap test"
                        (click)="onClickSearchByPartNameResult(result.product_key, result.name)"
                        [innerHTML]="highlightKeyword(result.name)">
                    </a>
                </div>
                <!-- <div *ngFor="let variation of result.product_variations" [ngClass]="{'border-bt': !last}">
                    <a type="button" class="dropdown-item text-wrap test"
                        (click)="onClickVariationResult(result.name, variation)"
                        [innerHTML]="highlightKeyword(variation.sku + ' - ' + result.name)">
                    </a>
                </div> -->
            </ng-container>
            <ng-container *ngFor="let cat of searchResultArrayByCatName ;let last = last ">
                <div [ngClass]="{'border-bt': !last}">
                    <a type="button" class="dropdown-item text-wrap test" (click)="subCategoriesRedirection(cat)"
                        [innerHTML]="highlightKeyword(cat.name)">
                    </a>
                </div>
            </ng-container>
        </div>
    </div>
    <ng-container *ngIf="noResult == true">
        <div class="position-absolute w-100 zindex-dropdown">
            <div class="dropdown-menu show w-100  shadow-sm border">
                <div><a type="button" class="dropdown-item text-wrap test">Result Not Found</a></div>
            </div>
        </div>
    </ng-container>
</div>